import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Space } from "antd";
import { getMyRequests, getRequestsToApprove } from "../../actions";
import { isLoading } from "../../selectors";
import { Requests } from "@authzsvc/common-react-components";
import { setBreadcrumbs } from "../../actions";
import { useNavigate } from "react-router-dom";

const RequestsWrapper = ({
  myRequests,
  loadingMyRequests,
  loadingToApprove,
  toApprove,
  setBreadcrumbs,
  breadcrumbs,
  getMyRequests,
  getRequestsToApprove,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
    getMyRequests();
    getRequestsToApprove();
  }, [setBreadcrumbs, breadcrumbs, getRequestsToApprove, getMyRequests]);

  const handleSelect = (request) => {
    if (request) {
      navigate(`/requests/${request.id}`);
    }
  };

  return (
    <Space vertical={true} size="middle">
      <div />
      <Requests
        onSelect={(request) => handleSelect(request)}
        myRequests={myRequests}
        toApprove={toApprove}
        loadingToApprove={loadingToApprove}
        loadingMyRequests={loadingMyRequests}
      />
    </Space>
  );
};

export default connect(
  (state) => ({
    loadingMyRequests: isLoading(state, "getMyRequests"),
    loadingToApprove: isLoading(state, "getRequestsToApprove"),
    myRequests: state.applicationRequests.my,
    toApprove: state.applicationRequests.toApprove,
  }),
  { setBreadcrumbs, getMyRequests, getRequestsToApprove },
)(RequestsWrapper);

RequestsWrapper.propTypes = {
  myRequests: PropTypes.array,
  loadingMyRequests: PropTypes.bool,
  loadingToApprove: PropTypes.bool,
  toApprove: PropTypes.array,
  setBreadcrumbs: PropTypes.func,
  breadcrumbs: PropTypes.array,
  getMyRequests: PropTypes.func,
  getRequestsToApprove: PropTypes.func,
};
